import { Equipment, Location } from './assets';

export enum RentalStatus {
  WAITING_PAYMENT = 0,
  NOT_STARTED = 1,
  RENTED = 2,
  RETURNED = 3,
  CLOSED = 4,
}

export interface RentalUser {
  sosFirstname?: string;
  sosLastname?: string;
  sosPhone?: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export enum RentalDurationUnit {
  DAY = 'day',
  HOUR = 'hour',
}

export interface RentalDuration {
  id: number;
  unit: RentalDurationUnit;
  duration: number;
}

export enum PaymentMethod {
  STRIPE = 'STRIPE',
  CASH = 'CASH',
}

export interface Invoice {
  id: number;
  stripePaymentIntentId: string | null;
  amount: number;
  finalPrice?: number;
  status: string;
  paymentMethod?: PaymentMethod;
  createdAt: string;
  updatedAt: string;
}

export interface RentalCode {
  token: string;
  revoked: boolean;
  locks?: { id: number }[];
}

// One rental status transition from the API audit trail (rental_events).
export interface RentalEvent {
  id: number;
  previousStatus: RentalStatus | null;
  newStatus: RentalStatus;
  cause: string;
  actorUserId: number | null;
  details: string | null;
  createdAt: string;
  actor?: { id: number; firstName?: string; lastName?: string } | null;
}

export interface Rental {
  id: number;
  createdAt: number;
  startDateUTC: string;
  endDateUTC: string ;
  comment?: string;
  token?: string;
  publicId: string;
  rentalStatus: RentalStatus;
  price: number;
  deposit: number;
  locationId: number;
  stationId?: number;

  location?: Pick<Location, 'name'>;
  equipments?: Equipment[];
  codes?: RentalCode[];
  user: RentalUser;
  invoice?: Invoice;
  events?: RentalEvent[];
}

export interface AvailableEquipment {
  id: number;
  model: string;
  imageUrl: string;
  type: number;
  lockId: number;
  lock?: {
    id: number;
    position: number;
    active: boolean;
  };
  // Price (cents) this equipment would cost for the swapped-into rental's actual
  // duration, priced at the plain hourly rate — null if it has no hourly pricing.
  priceForRentalDuration: number | null;
}
